const SESSIONINFO_KEY = 'userInfo';
/**
 * en backend es el sessionInfo: apiService.post('/api/main/session/getSessionInfo')
 * pero en frontend, desde el login/ lo cargamos en sessionStorage como userInfo
 *
 * 05/2004 Para que no se cargue en instancias diferentes del sessionInfo nos apoyamos
 * en una variable global ediwin.userInfo.
 * En el momento quitemos angularjs deberiamos comprobar si solo se carga una vez este import
 * y por tanto podriamos quitar el uso de la variable global
 */
const userInfoItem = sessionStorage.getItem(SESSIONINFO_KEY) ?? '{}';

window.ediwin = window.ediwin || {};
if (!window.ediwin.userInfo) {
  window.ediwin.userInfo = JSON.parse(userInfoItem);
}
const tagsItem = sessionStorage.getItem('tags') ?? '[]';
export const tags = JSON.parse(tagsItem);

if (!window.ediwin.userInfo.configUsuario) {
  window.ediwin.userInfo.configUsuario = {};
}

if (!window.ediwin.userInfo.userSecurityWebOptions) {
  window.ediwin.userInfo.userSecurityWebOptions = {};
}

// Desglosamos las tres partes del sessionInfo
export const sessionInfo = window.ediwin.userInfo;
export const configUsuario = window.ediwin.userInfo.configUsuario;
export const userSecurityWebOptions = window.ediwin.userInfo.userSecurityWebOptions;

export function setSessionInfo(data) {
  sessionStorage.setItem(SESSIONINFO_KEY, JSON.stringify(data));
}
